
jQuery(document).ready(function($) {
  $(document).foundation();

  // height 100%
  $(window).on('resize', function() {
    var windowInnerHeight = window.innerHeight
    $('.cell-content').css({ height: windowInnerHeight })
    if (Foundation.MediaQuery.is('medium up')) {
      $('.coming-soon-form').css({ height: windowInnerHeight })
    } else {
      $('.coming-soon-form').css({ height: 'auto' })
    }
  }).trigger('resize')

  // toggle sidebar
  $('.coming-soon-activator').on('click', function(e) {
    $('body').toggleClass('coming-soon--is-showing')
    e.preventDefault()
  })

  // form mailchimp
  $('form').on('submit', function(e) {
    $('form').removeClass('show-thanks show-error')
    e.preventDefault()
    var data = {
      email: $('input[type="email"]').val()
    }
    $.ajax({
      type: "POST",
      url: "mailchimp.php",
      data: data,
      dataType: "json",
      success: function(response) {
        if (response.success == false) {
          $('form').addClass('show-error')
        } else {
          $('form').addClass('show-thanks')
        }
      }
    })
    return false
  })

  // fade in
  setTimeout(function() {
    $('h5').addClass('is--showing')
  }, 1000);

  setTimeout(function() {
    $('h2').addClass('is--showing')
  }, 1500);
  
  // Team Modal
  var $body = $('html,body');
  $('.js-team-item').on('click', function (e) {
    e.preventDefault();
    var $trigger = $(this);
    var target = $trigger.attr('href');
    var $target = $(target);
    
    if ($target.length > 0) {
      $body.addClass('team-modal-opened');

      var tl = window.anime.timeline({
        easing: 'easeOutExpo',
        duration: 750
      })

      tl.add({
        targets: $target.get(0),
        opacity: [0, 1],
        translateY: [50, 0],
        begin: function() {
          $target.show();
          $target.addClass('active');
        },
      })

      window.anime({
        easing: 'easeOutExpo',
        duration: 250,
        targets: '.team-modal-overlay',
        opacity: [0, 0.7],
        begin: function() {
          $('.team-modal-overlay').show();
        }
      })
    }
  })

  $('.team-modal__close, .team-modal__overlay').on('click', function (e) {
    $body.removeClass('team-modal-opened');
    var $target = $('.team-modal.active');
    var tl = window.anime.timeline({
      easing: 'easeOutExpo',
      duration: 750
    })

    tl.add({
      targets: $target.get(0),
      opacity: [1, 0],
      translateY: [0, -50],
      complete: function() {
        $target.hide();
        $target.removeClass('active');
      },
    });

    window.anime({
      easing: 'easeOutExpo',
      duration: 250,
      targets: '.team-modal-overlay',
      opacity: [0, 0.7],
      begin: function() {
        $('.team-modal-overlay').hide();
      }
    })
  });

  // Mobile Menu
  var $mobileMenu = $('.mobile-menu-button');
  var $mobileButtonBar = $mobileMenu.find('.bar');
  var menuActive = false;

  $mobileMenu.on('click', function (e) {
    e.preventDefault();

    if (!menuActive) {
      menuActive = true;
      openMobileMenu();
    } else {
      menuActive = false;
      closeMobileMenu();
    }
  });

  // Open Menu
  function openMobileMenu() {
    var buttonTl = window.anime.timeline({
      easing: 'easeInOutCubic',
      duration: 500,
      complete: function() {
        $mobileMenu.addClass('active');
      }
    });

    buttonTl.add({
      targets: $mobileButtonBar.eq(0).get(0),
      keyframes: [
        {
          translateY: [0, 6],
        },
        {
          rotate: 45,
        }
      ]
    });
    buttonTl.add({
      targets: $mobileButtonBar.eq(1).get(0),
      opacity: [1, 0]
    }, 0);
    buttonTl.add({
      targets: $mobileButtonBar.eq(2).get(0),
      keyframes: [
        {
          translateY: [0, -6],
        },
        {
          rotate: -45,
        },
      ],
    }, 0);

    var menuTl = window.anime.timeline({
      easing: 'easeInOutCubic',
    });

    menuTl.add({
      duration: 500,
      opacity: [0, 1],
      targets: '.js-mobile-menu',
      begin: function() {
        $body.addClass('mobile-menu-opened');
      }
    });
    menuTl.add({
      duration: 250,
      opacity: [0, 1],
      translateY: ['50%', '0%'],
      delay: anime.stagger(120),
      targets: '.mobile-menu__nav li',
    })
  }

  // Close Menu
  function closeMobileMenu() {
    var buttonTl = window.anime.timeline({
      easing: 'easeInOutCubic',
      duration: 500,
      complete: function() {
        $mobileMenu.addClass('active');
      }
    });

    buttonTl.add({
      targets: $mobileButtonBar.eq(0).get(0),
      keyframes: [
        {
          rotate: [45, 0],
        },
        {
          translateY: [6, 0],
        },
      ]
    });
    buttonTl.add({
      targets: $mobileButtonBar.eq(1).get(0),
      opacity: [0, 1]
    }, 0);
    buttonTl.add({
      targets: $mobileButtonBar.eq(2).get(0),
      keyframes: [
        {
          rotate: [-45, 0],
        },
        {
          translateY: [-6, 0],
        },
      ],
    }, 0);

    var menuTl = window.anime.timeline({
      easing: 'easeInOutCubic',
    });

    menuTl.add({
      duration: 250,
      opacity: [1, 0],
      translateY: ['0%', '-50%'],
      delay: anime.stagger(120),
      targets: '.mobile-menu__nav li',
    });
    menuTl.add({
      duration: 500,
      opacity: [1, 0],
      targets: '.js-mobile-menu',
      complete: function() {
        $body.removeClass('mobile-menu-opened');
      }
    });
  }

  // Set minimal height of the site-main
  var $siteHeader = $('.site-header');
  var $siteFooter = $('.site-footer');
  var $siteMain = $('.site-main');
  var $homeSection = $('.hero-section');
  function setMainMinimalHeight() {
    var headerHeight = $siteHeader.outerHeight();
    var footerHeight = $siteFooter.outerHeight();
    var mainHeight = $(window).innerHeight() - (headerHeight + footerHeight);
    $siteMain.css('min-height', mainHeight + 'px');
    
    if ($homeSection.length > 0) {
      $homeSection.css('min-height', mainHeight + 'px');
    }
  }
  setMainMinimalHeight();

  $(window).on('load', setMainMinimalHeight);
  $(window).on('resize', $.debounce(250, setMainMinimalHeight));
})
